// @ts-nocheck
import React from 'react';
import WorkflowPage from './WorkflowPageFactory';
import { BaseAmount as BaseAmountForm } from '../workflow/CompanyApp';

export default function BaseAmountPage() {
  return (
    <WorkflowPage stepId="baseAmount">
      {({ data, setData, navigateTo }) => (
        <BaseAmountForm formData={data} setFormData={setData} setActiveTab={navigateTo} />
      )}
    </WorkflowPage>
  );
}
